import { type ReactNode } from 'react';
import { Button } from './Button';
import { Icon } from './Icon';

interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  retryLabel?: string;
  action?: ReactNode;
}

// Airbnb error state — soft pink surface, warm error text, ghost retry
export function ErrorState({
  title = '문제가 발생했어요',
  description = '잠시 후 다시 시도해주세요.',
  onRetry,
  retryLabel = '다시 시도',
  action,
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      aria-live="assertive"
      className="rounded-[22px] bg-error-soft p-7 text-center"
    >
      <div
        aria-hidden="true"
        className="mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-error/10 text-error"
      >
        <Icon name="x" size={20} />
      </div>
      <p className="text-feature font-semibold tracking-tight-feature text-error">{title}</p>
      {description && <p className="mt-1.5 text-body text-ink-muted">{description}</p>}
      <div className="mt-5 flex justify-center gap-2">
        {onRetry && (
          <Button variant="ghost" onClick={onRetry}>
            {retryLabel}
          </Button>
        )}
        {action}
      </div>
    </div>
  );
}
